module.exports = {"branch":"","commit":"","version":"0.0","build_date":""}


//////////////////
// WEBPACK FOOTER
// ./src/status.json
// module id = 459
// module chunks = 0